/**
 * Utility functions for grade-related operations
 */

const gradeNumberTogradeName = {
  0: 'KINDERGARTEN',
  1: 'FIRST',
  2: 'SECOND',
  3: 'THIRD',
  4: 'FOURTH',
  5: 'FIFTH',
  6: 'SIXTH',
  7: 'SEVENTH',
  8: 'EIGHTH',
  9: 'NINTH',
} as const;

/**
 * Helper function to find the most common grade number from a list of students
 * @param students Array of student objects with grade property
 * @returns The most common grade as a number, or 0 if no students
 */
function findMostCommonGradeNumber(students: any[]): number {
  if (!students || students.length === 0) return 0;

  const gradeCount = new Map<number, number>();
  let maxCount = 0;
  let mostCommonGrade = 0;

  for (const student of students) {
    const count = (gradeCount.get(student.grade) || 0) + 1;
    gradeCount.set(student.grade, count);

    if (count > maxCount) {
      maxCount = count;
      mostCommonGrade = student.grade;
    }
  }

  return mostCommonGrade;
}

/**
 * Gets the most common grade from a list of students
 * @param students Array of student objects with grade property
 * @returns The most common grade as a string (e.g., 'FIRST', 'SECOND', etc.)
 */
export function getMostCommonGrade(students: any[]): string {
  const mostCommonGradeNumber = findMostCommonGradeNumber(students);
  return gradeNumberTogradeName[mostCommonGradeNumber as keyof typeof gradeNumberTogradeName] || '';
}

/**
 * Gets the most common grade number from a list of students
 * @param students Array of student objects with grade property
 * @returns The most common grade as a number (e.g., 0, 1, 2, etc.)
 */
export function getMostCommonGradeNumber(students: any[]): number {
  const mostCommonGradeNumber = findMostCommonGradeNumber(students);
  return mostCommonGradeNumber ?? 1; // Default to 1 if no students found
} 